import React, { Component } from "react";
import "./styles.css";
import E from "../../../js/events";
// import Divider      from "../../prefabs/divider/view";
import InputCounter from "../../widgets/input-counter/view";
// import InputToggle  from "../../widgets/input-toggle/view";

class SectionPackage extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.handleKidsCount     = this.handleKidsCount.bind(this);
    this.handleAdultsCount   = this.handleAdultsCount.bind(this);
    // this.handlePremiumToggle = this.handlePremiumToggle.bind(this);
  }



  // ===============================================================================================
  handleKidsCount(amount) {
    let newAmount = amount - this.props.minChildren;
    this.props.handleAppEvent(E.events.PACKAGE_MOD_CHILD, newAmount);
  }



  // ===============================================================================================
  handleAdultsCount(amount) {
    this.props.handleAppEvent(E.events.PACKAGE_MOD_ADULT, amount);
  }



  // ===============================================================================================
  // handlePremiumToggle(toggle) {
  //   this.props.handleAppEvent(E.events.PACKAGE_MOD_PREMIUM, toggle);
  // }



  // ===============================================================================================
  render() {

    let priceSuffix = {
      "hosted": "* per child",
      "no-host": "* per person"
    };

    let selLocation = this.props.selLocation;
    // If we have location specific products, use them, otherwise use the default products
    let products = (selLocation && selLocation.products) || this.props.products;

    let costStandard = (products['happy_party_package']) ? products['happy_party_package'].price : 0;
    let costNoHost   = (products['no_host_package']) ? products['no_host_package'].price : 0;

    let costCurrentEventType = (this.props.eventType === "no-host") ? costNoHost : costStandard;

    // ---------------------------------------------------------------------------------------------
    // Children counter
    let curChilds = this.props.minChildren + this.props.numChildren;
    let minChilds = this.props.minChildren;
    if (this.props.selLocation) {
      minChilds = (this.props.selLocation.min_capacity > minChilds) ? this.props.selLocation.min_capacity : minChilds;
    }
    let maxChilds = (this.props.selLocation) ? this.props.selLocation.max_capacity : 100; 

    if (curChilds < minChilds) {
      curChilds = minChilds;
    }

    if (curChilds > maxChilds && maxChilds > minChilds) {
      curChilds = maxChilds;
    }

    // ---------------------------------------------------------------------------------------------
    // Adult counter
    let curAdults = this.props.numAdults;
    let minAdults = 1;
    let maxAdults = maxChilds;

    let minTooltip = {
      "hosted": "",
      "no-host": ""
    };

    let maxTooltip = {
      "hosted": "",
      "no-host": ""
    };

    if (this.props.selLocation && this.props.selLocation.title) {
      minTooltip = {
        "hosted": `${this.props.selLocation.title} has a minimum capacity of ${minChilds} children.`,
        "no-host": `${this.props.selLocation.title} has a minimum capacity of ${minChilds} people.`
      };

      maxTooltip = {
        "hosted": `${this.props.selLocation.title} has a maximum capacity of ${maxChilds} children.`,
        "no-host": `${this.props.selLocation.title} has a maximum capacity of ${maxChilds} people.`
      };
    }

    // ---------------------------------------------------------------------------------------------
    return (
      <div className="cont-section cont-section--offset-header cont-section--offset-footer cont-section--offset-sidebar cont-section--package">
        <div className="cont-wrapper">


          {this.props.eventType === 'hosted' && (
            <>
              <h1>
                Celebrate with 'The Classic Party Package'
              </h1>
      
              <p>
                Our classic package comes with all McDonald's Parties.<br/>
                Package includes:
              </p>
              <ul>
                <li> Personal Party Host                   </li>
                <li> 90 minutes of fun and games           </li>
                <li>
                     Happy Meal<sup>®</sup> menu selection including Happy Meal Toy, per child
                     <span className="total-disc Mcd_BPB__disclaimer-text">*</span>
                </li>
                <li> Happy Celebration Pack/Party Bag, per child      </li>
                <li> Invitations and a Birthday Card, per child       </li>
                <li> Hats, tray mats and crayons, per child           </li>
                <li> Gift for birthday child                          </li>
              </ul>
            </>
          )}

          {this.props.eventType === 'no-host' && (
            <>
              <h1>
                Book an Event Space
              </h1>

              <p>The hire of a room or space within a McDonald's Restaurant.</p>
              <p>This includes:</p>
              <ul>
                <li>90 minute room/space hire. Set-up and Pack-down completed by the customer is included in this time. </li>
                <li>Ability to add-on items (per piece) such as ice cream cakes, invitations, bunting, colouring packs, party hats, party bags and surprise birthday gifts.</li>
              </ul>
            </>
          )}



          <InputCounter
            label={costCurrentEventType === 0 ? "" : "$" + (costCurrentEventType / 100).toFixed(2) + priceSuffix[this.props.eventType]}
            amount={curChilds}
            min={minChilds}
            max={maxChilds}
            minTooltip={minTooltip[this.props.eventType]}
            maxTooltip={maxTooltip[this.props.eventType]}
            handleChange={this.handleKidsCount}
          />



          {this.props.eventType === 'hosted' && (
            <InputCounter
              label="Adults (Free)"
              amount={curAdults}
              min={minAdults}
              max={maxAdults}
              handleChange={this.handleAdultsCount}
            />
          )}

        </div>
      </div>
    );
  }

}



export default SectionPackage
